import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-state-column-molecule',
  templateUrl: './state-column-molecule.component.html',
  styleUrls: ['./state-column-molecule.component.scss']
})
export class StateColumnMoleculeComponent {
  @Input() data: any;
  @Input() header: any;
}
